import React from 'react';

import { reduxConnect } from '../../common';
import { DailyForecastSummaryItem } from './dailyForecastSummaryItem';
import { DailyForecastPeriod, IStoreState } from '../common/interfaces/types';
import { defaultReading } from '../forecasts/common/utils';

interface DailyForecastSummaryListProps {
    dailyForecastPeriods: DailyForecastPeriod[];
    dailyForecastIsRefreshing: boolean;
}

const defaultIconCode = 999;

const mapStoreStateToProps = (storeState: IStoreState) => {
    const { forecast } =  storeState || {};
    const { daily, dailyForecastIsRefreshing } = forecast || {};

    return {
        dailyForecastPeriods: daily?.dfp,
        dailyForecastIsRefreshing
    };
};

const mapDispatchToProps = {};

export const DailyForecastSummaryList = reduxConnect(mapStoreStateToProps, mapDispatchToProps)(({ 
    dailyForecastPeriods, 
    dailyForecastIsRefreshing }: DailyForecastSummaryListProps) => {
    
    if (!dailyForecastPeriods?.length && dailyForecastIsRefreshing) {
        return (
            Array.from(Array(2).keys()).map(summaryItemLoadingNumber => {
                return <DailyForecastSummaryItem 
                    key={`animated-loading-ui#${summaryItemLoadingNumber}`}
                    isLoadingForecast={dailyForecastIsRefreshing}
                    forecastIndex={summaryItemLoadingNumber}
                    temperature={defaultReading}
                />;
            })
        );
    }

    const forecasts = dailyForecastPeriods?.slice(0, 2);
    
    return (
        <>
            {forecasts?.map((forecast, index) => 
                <DailyForecastSummaryItem 
                    isLoadingDailyForecast={dailyForecastIsRefreshing} 
                    iconCode={forecast?.ic ?? defaultIconCode}
                    isNightTimePeriod={forecast?.intp}
                    detailedDescription={forecast?.dd}
                    temperature={forecast?.t}
                    forecastIndex={index} 
                    key={`${index}__forecast__summary`} />
            )}
        </>
    );
});
